export function loadDevModules(moduleId, moduleName) {
  return new Promise((resolve, reject) => {
    function timeOutLoad(resolve, reject) {
      if (window.e9_registed_coms) {
        window.eventRegister &&
          window.eventRegister.loadModule(
            moduleId,
            () => {
              resolve();
            },
            () => {
              const msg = `${moduleName} 加载失败`;
              reject(msg);
            }
          );
      } else {
        setTimeout(() => {
          timeOutLoad(resolve, reject);
        }, 100);
      }
    }
    timeOutLoad(resolve, reject);
  });
}



// WEBPACK FOOTER //
// ./ecology9/wea-tools/loadDevModules.js